import React, { Component, Fragment } from 'react';
import { __, __route } from "localisation";
import { DualBox, DualBoxLeft, DualBoxRight } from 'components/DualBox';
import CreateForm from 'modules/CreateForm';
import getFormData from './autogiroData';
import { filterToString } from 'modules/CreateForm/FilterMethods';
import { connect } from 'react-redux';
import { userAccountsOperations } from '../../state/ducks/userAccounts';
import { authOperations } from '../../state/ducks/auth';
import Icon from '@hubins/components/IconNew';
import Main from 'components/Main';
import LoadingModal from 'components/Modal/LoadingModal';
import Heading from 'components/Heading';

const Autogiro = ({ fetchAccounts, juridical, setAccounts, sendKYC, userAccounts }) => {
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    fetchAccounts().then((accounts) => {
      setAccounts(accounts);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <LoadingModal />;
  }


  const key = juridical === "PE" ? "contact.registration.prepare_for_autogiro" : "contact.company.prepare_for_autogiro";
  const formData = getFormData(userAccounts[0].customer_account_number, key);
  return (
    <>
      <Main>
        <Heading center className="section-padding">{__('register_for_autogiro')}</Heading>
        <DualBox className="dualbox--wide">
          <DualBoxLeft className="dualbox__box--wide dualbox__box--tight">
            <CreateForm
              className="wide"
              formData={formData}
              submitType={sendKYC}
              submitText={__('Accept_and_proceed')}
              // buttonProps={{ icon: 'save' }}
              buttonStyle="wide cta" // just for clearing wide
              filter={filterToString}
              redirect={__route('root')}
            />
          </DualBoxLeft>

          <DualBoxRight className="dualbox__box--top dualbox__box--tight neutral-3">
            <Icon icon="Information Circle by Streamlinehq" size={16} className="dualbox__icon" color="white" />
            <Heading element="h3" size="4">{__('good_to_know')}</Heading>
            <p>{__('autogiro_transfer_info')}</p>
          </DualBoxRight>
        </DualBox>
      </Main>
    </>
  );


};

function mapStateToProps(state) {
  return {
    userAccounts: state.userAccounts.Index,
    userAccountsStatus: state.userAccounts.Status,
    juridical: state.auth.User.active_profile.fa_connection.contact_juridical
  };
}

const mapDispatchToProps = {
  fetchAccounts: userAccountsOperations.fetchAccounts,
  sendKYC: authOperations.sendKYC,
  setAccountsStatus: userAccountsOperations.setAccountsStatus,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Autogiro);
